import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c131657")

_pushScopeId("data-v-3c131657")
const _hoisted_1 = { class: "pop-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"pop-wrapper-background-top\" data-v-3c131657><div class=\"red-bg\" data-v-3c131657></div><div class=\"red-ornament\" data-v-3c131657></div></div><div class=\"pop-wrapper-background-back\" data-v-3c131657><div class=\"back-left-top\" data-v-3c131657></div><div class=\"back-left-top-line\" data-v-3c131657></div><div class=\"top-line\" data-v-3c131657></div><div class=\"back-right-top-line\" data-v-3c131657></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: `pop-background ${_ctx.template === 'normal' ? 'normal' : ''}`
      }, [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", {
            class: "pop-container",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"]))
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.answerComponent), {
              data: _ctx.data,
              onPopclose: _ctx.popClose,
              onAction: _ctx.doAction,
              onClose: _ctx.popClose
            }, null, 8, ["data", "onPopclose", "onAction", "onClose"]))
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
})